export default "__VITE_ASSET__DSJwCdyf__"